export default __webpack_public_path__ + "static/media/ufo-2.faae30a2.jpg";